import ButtonVektor from './button-vektor';
export default ButtonVektor;
